import { AcceptInvitePage } from '@agentic-flow-studio/shared/components/invite/AcceptInvitePage';
import { SkillViperLogo } from '@agentic-flow-studio/shared/components/skill-viper-logo';
import { inviteAuthPath } from '@agentic-flow-studio/shared/lib/invite-links';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authClient } from '@/utils/betterAuth';

export default function AcceptInvite() {
  const { data: session } = authClient.useSession();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';

  return (
    <AcceptInvitePage
      brandName="Skill Viper"
      logo={<SkillViperLogo className="h-8 w-8" />}
      currentUserEmail={session?.user.email}
      onSwitchAccount={() => {
        authClient.signOut();
        navigate(inviteAuthPath('login', token));
      }}
    />
  );
}
